import React from "react";
import "./BannerTitle.css";

const BannerTitle = ({ firstText, highlightText, bannerSubText }) => {
  return (
    <div className="container">
      <div className="banner-title">
        <h1 className="banner-title_heading">
          <span className="banner-title_text">{firstText} </span>
          <span className="banner-title_highlight">{highlightText}</span>
        </h1>
        <p className="sub-text">{bannerSubText}</p>
      </div>
    </div>
  );
};

export default BannerTitle;
